export default IconArrowRightToArc => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-right-to-arc" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 12h12" />
  <path d="M11 8l4 4l-4 4" />
  <path d="M12 21a9 9 0 0 0 0 -18" />
</svg>`;